import { TIME_PERIOD } from '../../shared/time-filters/filters.constants';

export const LAST_PERIOD_LABELS: Partial<Record<TIME_PERIOD, string>> = {
  [TIME_PERIOD.WEEK]: 'La semaine précédente',
  [TIME_PERIOD.MONTH]: 'Le mois précédent',
  [TIME_PERIOD.YEAR]: "L'année précédente",
  [TIME_PERIOD.CUSTOM]: 'La période précédente',
};
